export default {
  BusinessStockEntryInform: {
    header: {
      queryCode: '单号',
      queryCodeText: '入库通知单号/客户订单号/内部单号/前置单号',
      status: '入库状态',
      receivingLogicWarehouseCode: '入库逻辑仓',
      receivingLogicWarehouseCodeText: '请输入逻辑仓编码',
      beginCreationDate: '创建时间',
    },

    table: {
      code: '入库通知单号',
      platformOrderCode: '客户订单号',
      orderCode: '内部单号',
      frontRecordCode: '前置单号',
      inputTypeMeaning: '入库类型',
      statusMeaning: '入库状态',
      qty: '需入库数量',
      receivingLogicWarehouseCode: '入库逻辑仓编码',
      receivingLogicWarehouseName: '入库逻辑仓名称',
      storeName: '销售店铺',
      channelTypeCodeMeaning: '销售渠道',
      creationDate: '创建时间'
    }
  },
  BusinessStockEntryInformView: {
    title: '基本信息',
    code: '入库通知单号',
    receivingLogicWarehouseCode: '入库逻辑仓编码',
    receivingLogicWarehouseName: '入库逻辑仓名称',
    inputTypeMeaning: '入库类型',
    statusMeaning: '入库状态',
    returnsName: '退货人',
    returnsMobile: '退货人手机号',
    cptAddress: '退货人地址',
    creationDate: '创建时间',
    logisticsInformation: '物流信息',
    associated: '关联单据',
    frontRecordCode: '前置单号',
    orderCode: '内部订单号',
    platformOrderCode: '客户订单号',
    resultCode: '入库结果单号',
    productInformation: '商品信息',
    totalQty: '入库总数量',
    alreadyTotalQty: '已入库数量',
    noDataText: '暂无',

    table: {
      // spuCode: '商品编码',
      skuName: 'SKU名称',
      skuCode: 'SKU编码',
      plannedQty: '入库数量',
      alreadyInputQty: '已入库数量',
      // spuName: '商品名称',
    }
  }
};
